const defaultOptions = {
  "parserOptions": {
    "ecmaVersion": 5,
    "sourceType": "script",
    "ecmaFeatures": {
      // "impliedStrict": true
    }
  },
  //https://eslint.org/docs/rules/
  "rules": {
    "constructor-super": true,

    //enforce “for” loop update clause moving the counter in the right direction.
    "for-direction": true,

    //enforce return statements in getters
    "getter-return": true,

    //disallow lexical declarations in case clauses
    "no-case-declarations": true,

    // disallow comparing against -0
    "no-compare-neg-zero": true,

    //disallow assignment operators in conditional expressions
    "no-cond-assign": true,

    //disallow the use of console
    "no-console": false,

    //require or disallow strict mode directives
    // "strict": true,

    // disallow constant expressions in conditions
    "no-constant-condition": true,

    //disallow control characters in regular expressions
    "no-control-regex": true,

    // disallow the use of debugger
    "no-debugger": false,

    //disallow deleting variables
    "no-delete-var": true,

    //disallow duplicate arguments in function definitions
    "no-dupe-args": true,

    //disallow duplicate class members
    "no-dupe-class-members": true,

    //disallow duplicate keys in object literals
    "no-dupe-keys": true,

    //disallow duplicate case labels
    "no-duplicate-case": true,

    //disallow empty character classes in regular expressions
    "no-empty-character-class": true,

    //disallow empty destructuring patterns
    "no-empty-pattern": true,

    //disallow empty block statements
    "no-empty": true,

    //disallow reassigning exceptions in catch clauses
    "no-ex-assign": true,

    //disallow unnecessary boolean casts
    "no-extra-boolean-cast": true,

    //disallow unnecessary semicolons
    "no-extra-semi": true,

    //disallow fallthrough of case statements
    "no-fallthrough": true,

    //disallow reassigning function declarations
    "no-func-assign": true,

    //disallow assignments to native objects or read-only global variables
    "no-global-assign": true,

    //disallow variable or function declarations in nested blocks
    "no-inner-declarations": true,

    //disallow invalid regular expression strings in RegExp constructors
    "no-invalid-regexp": true,

    //disallow irregular whitespace outside of strings and comments
    "no-irregular-whitespace": true,

    //disallow mixed spaces and tabs for indentation
    "no-mixed-spaces-and-tabs": false,

    //disallow new operators with the Symbol object
    "no-new-symbol": true,

    //disallow calling global object properties as functions
    "no-obj-calls": true,

    //disallow octal literals
    "no-octal": true,

    //disallow variable redeclaration
    "no-redeclare": true,

    //disallow multiple spaces in regular expressions
    "no-regex-spaces": true,

    //disallow assignments where both sides are exactly the same
    "no-self-assign": true,

    //disallow sparse arrays
    "no-sparse-arrays": true,

    //disallow this/super before calling super() in constructors
    "no-this-before-super": true,

    //disallow the use of undeclared variables unless mentioned in /*global */ comments
    "no-undef": true,

    //disallow confusing multiline expressions
    "no-unexpected-multiline": true,

    //disallow unreachable code after return, throw, continue, and break statements
    "no-unreachable": true,

    //disallow control flow statements in finally blocks
    "no-unsafe-finally": true,

    //disallow negating the left operand of relational operators
    "no-unsafe-negation": true,

    //disallow unused labels
    "no-unused-labels": true,

    //disallow unused variables
    "no-unused-vars": false,

    //disallow unnecessary escape characters
    "no-useless-escape": true,

    //require generator functions to contain yield
    "require-yield": true,

    //require calls to isNaN() when checking for NaN
    "use-isnan": true,

    //enforce comparing typeof expressions against valid strings
    "valid-typeof": true
  },
  "env": {
    browser: true,
    es6: false,
    jquery: true
  }
};

export default function (code, options = defaultOptions) {
  return new Promise((resolve,reject)=>{
    if (window.eslint) {
      const EsLint = new eslint();
      resolve(EsLint.verify(code, options));
    }else{
      PF.requireJs('/assets/js/eslint/eslint.min.js',function(){
        const EsLint = new eslint();
        resolve(EsLint.verify(code, options));
      });
    }
  });

}



// WEBPACK FOOTER //
// ./src/common/utils/eslint.js